module.exports = __webpack_public_path__ + "static/img/home_lun4.15a24d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/home_lun4.jpg
// module id = WSMF
// module chunks = 1